import React, { useState, useEffect, useCallback } from 'react'

// Deps
import config from 'config'
import GoogleMapReact from 'google-map-react';

export const MapElement = ({ className, children, zoom, lat, lng, ...props }) => {
	return (
		<div className={'mapelement ' + className}>
			<GoogleMapReact
				bootstrapURLKeys={{ key: config.maps.apiKey }}
				defaultCenter={{
					lat: lat,
					lng: lng,
				}}
				defaultZoom={zoom}>
				{children}
			</GoogleMapReact>
		</div>
	)
}

MapElement.defaultProps = {
	className: '',
	zoom: 19,
	lat: 39.934383,
	lng: 32.8877025,
}

export const MapMarker = ({ infoBar, className, ...props }) => {
	const [showInfobar, setShowInfobar] = useState(false);

	const infobarEvent = useCallback(() => {
		if(showInfobar) {
			setShowInfobar(false);
		}
	}, [showInfobar]);

	useEffect(() => {
		document.addEventListener("maps-infobar-open", infobarEvent, false);
	}, [infobarEvent])

	return (
		<div className={'mapelement-marker custom ' + className + (showInfobar ? ' infobar-open' : '')}>
			<button
				className="marker-btn"
				onClick={() => {
					if(!showInfobar) {
						const clickEvent = new Event('maps-infobar-open');
						document.dispatchEvent(clickEvent);
					}

					setShowInfobar(!showInfobar);
				}}>
				<i className="icon-map-pin" />
			</button>

			{(infoBar && showInfobar) &&
				<div className="marker-infobar">
					{infoBar}
				</div>
			}
		</div>
	)
}